// extracted by mini-css-extract-plugin
module.exports = {"base":"_3tx2xi","textBase":"_2EfpD0"};